module.exports = __webpack_public_path__ + "img/Tertiary-link-arrow_Text-precedes-this-arrow_02.de31f9cd.svg";